import React, { useState, useEffect } from 'react';
import { Translation, getI18n } from 'react-i18next';
import Logger from '../../../../../lib/Logger';
import LearningAdminFormHeader from './LearningAdminFormHeader';

import { Col, Row } from 'antd';
import ConfirmationModal from '../../../elements/components/ConfirmationModal';
import LearningAdminModuleSerieFormStep1 from '../containers/LearningAdminModuleSerieFormStep1Container';
import LearningAdminModuleSerieFormStep2 from '../containers/LearningAdminModuleSerieFormStep2Container';
import QueryString from '../../../../../lib/QueryString';
import { mixpanelEventsEnum } from '../../../../../lib/Mixpanel';
const confirmTexts = {
  title: getI18n().t('form_modal_leave_title'),
  description: getI18n().t('form_modal_leave_description'),
  leaveText: getI18n().t('form_modal_leave_cancel'),
  saveText: getI18n().t('form_modal_leave_save'),
};

const modules = {
  0: 'module_serie',
  1: 'module',
};

const LearningAdminModuleSerieForm = ({
  id,
  screen,
  data,
  load,
  history,
  trackerActions,
  ...props
}) => {
  const steps = [
    {
      title: id
        ? getI18n().t('learning_admin_form_module_serie_step_1_title_edit')
        : getI18n().t('learning_admin_form_module_serie_step_1_title_create'),
    },
    {
      title: id
        ? getI18n().t('learning_admin_form_module_serie_step_2_title_edit')
        : getI18n().t('learning_admin_form_module_serie_step_2_title_create'),
    },
  ];

  const [step, setStep] = useState(0);
  const [isChangeValue, setIsChangeValue] = useState(false);
  const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);
  const [targetPath, setTargetPath] = useState(null);
  const [oldParams, setOldParams] = useState(null);
  const [moduleSerieId, setModuleSerieId] = useState(null);
  const [pendingAction, setPendingAction] = useState(null);

  const { view, key } = QueryString.parse(props.location.search);

  const nextStep = async () => {
    setStep(step + 1);
    trackerActions(
      mixpanelEventsEnum.ACTIONS_PARTNER.LEARNINGS_ADMIN_NEXT_STEP_MODULE_SERIE
    );
  };

  const prevStep = () => {
    setStep(step - 1);
    trackerActions(
      mixpanelEventsEnum.ACTIONS_PARTNER.LEARNINGS_ADMIN_PREV_STEP_MODULE_SERIE
    );
  };

  const handleConfirmLeave = () => {
    setConfirmationModalOpen(false);
    setIsChangeValue(false);
  };

  const handleStayOnPage = () => {
    setConfirmationModalOpen(false);
    setTargetPath(null);
    setPendingAction(null);
  };

  useEffect(() => {
    const unblock = history.block((location) => {
      if (isChangeValue) {
        setTargetPath(location.pathname);
        setConfirmationModalOpen(true);
        return false;
      }
      return true;
    });
    return () => unblock();
  }, [history, isChangeValue]);

  useEffect(() => {
    if (targetPath && !confirmationModalOpen) {
      history.push(targetPath);
      if (pendingAction === 'back') {
        prevStep();
      }
      setTargetPath(null);
      setPendingAction(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [targetPath, confirmationModalOpen, history, pendingAction]);

  useEffect(() => {
    if (view && key && oldParams === null) {
      setOldParams({ view, key });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [view, key]);

  return (
    <Translation>
      {(t) => (
        <>
          <LearningAdminFormHeader
            id={id}
            step={step}
            steps={steps}
            module={modules[step]}
          />

          <Row justify='center' align='top'>
            <Col
              span={24}
              flex={'auto'}
              className={'learning-admin-module-serie-form-content-panel'}
            >
              {step === 0 && (
                <LearningAdminModuleSerieFormStep1
                  data={data}
                  id={id}
                  setModuleSerieId={setModuleSerieId}
                  setConfirmationModalOpen={setConfirmationModalOpen}
                  isChangeValue={isChangeValue}
                  modules={modules}
                  step={step}
                  setIsChangeValue={setIsChangeValue}
                  oldParams={oldParams}
                  setTargetPath={setTargetPath}
                  nextStep={nextStep}
                  screen={screen}
                  trackerActions={trackerActions}
                />
              )}

              {step === 1 && (
                <LearningAdminModuleSerieFormStep2
                  data={data}
                  moduleSerieId={moduleSerieId}
                  setConfirmationModalOpen={setConfirmationModalOpen}
                  isChangeValue={isChangeValue}
                  modules={modules}
                  step={step}
                  setIsChangeValue={setIsChangeValue}
                  oldParams={oldParams}
                  setTargetPath={setTargetPath}
                  nextStep={nextStep}
                  prevStep={prevStep}
                  view={view}
                  activeKey={key}
                  setPendingAction={setPendingAction}
                  screen={screen}
                  trackerActions={trackerActions}
                />
              )}
            </Col>
          </Row>

          <ConfirmationModal
            texts={confirmTexts}
            openConfirmationModal={confirmationModalOpen}
            onLeaveConfirmation={handleConfirmLeave}
            onSaveConfirmation={handleStayOnPage}
            onCancel={handleStayOnPage}
            setConfirmationModalOpen={setConfirmationModalOpen}
          />
        </>
      )}
    </Translation>
  );
};

export default LearningAdminModuleSerieForm;

Logger.log('silly', `LearningAdminModuleSerieForm loaded.`);
